import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cash-calc"
export default class extends Controller {
  static targets = [ "cash", "changeDue", "card"]
  connect() {
    const urlParams = new URLSearchParams(document.location.search);

    if (urlParams.get("internal_mode") === "true"){
    const cashCheckoutBtn = document.getElementById("checkout-cash-btn")
    const backCartBtn = document.getElementById("back-cart-btn")
    const cashSubmitBtn = document.getElementById("cash-submit-btn")
    cashCheckoutBtn.addEventListener("click", (event) => {
      this.cardTarget.classList.remove('d-none')
    });
    backCartBtn.addEventListener("click", (event) =>{
      this.cardTarget.classList.add('d-none')
    });
    cashSubmitBtn.addEventListener("click", (event) =>{
      this.cardTarget.classList.add('d-none')
    });
    //disable enter key on number input
    this.cashTarget.onkeypress = function(key) {
      var btn = 0 || key.keyCode || key.charCode; 
      if (btn == 13) { 
          key.preventDefault(); 
      } 
   }
   }
  }

  calc(){
    const regex = /^\d+(?:\.\d{1,2})?$/;
    const grandTotalCents = document.getElementById("grand_total").value
    const cashCents = (parseFloat(this.cashTarget.value) * 100 )
    if (cashCents == NaN || regex.test(this.cashTarget.value) == false || grandTotalCents > cashCents){
      console.log(`invalid number ${cashCents}`)
      this.changeDueTarget.innerText = ""
    }else {
    console.log(Math.floor(cashCents - grandTotalCents))
    this.changeDueTarget.innerText = (Math.floor(cashCents - grandTotalCents) / 100).toFixed(2)
    }
  }

}
